import {
  CognitoUser,
  CognitoUserPool,
  CognitoRefreshToken,
} from 'amazon-cognito-identity-js';
import Amplify, { graphqlOperation } from 'aws-amplify';
import CognitoIdentity from 'aws-sdk/clients/cognitoidentity';
import { config } from 'aws-sdk/global';

import get from 'lodash/get';
import apiConfig from '../../config/api';
import { actions as applicationActions } from '../Application';
import { getAllApplications, setLastActive } from './queries';

import { apiCall, redirectToLoginPage } from '../../services/initiation';

//  Shallow checks if one of the properties in an object is null. Does not work for deeper structrues.
const hasNull = (target) => {
  Object.keys(target).forEach(
    (prop) =>
      target[prop] === null && prop !== 'approvalStatus' && prop !== 'signLink'
  );
};

const getApprovalstatus = (target) => {
  if (!target.approvalStatus) return null;
  return target.approvalStatus.type;
};

// Actions
export function setLastActiveDate() {
  return (dispatch, getState) => {
    const { propositionID: id } = getState().app;
    if (!id) return;
    apiCall(graphqlOperation(setLastActive(id)))
      .then(() => {
        window.debug.log('Succesfully updated last active');
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };
}

export const setUpApp = () => (dispatch) => {
  Amplify.configure(apiConfig.amplifyConfig);

  config.region = apiConfig.amplifyConfig.Auth.region;

  dispatch({
    type: 'CONFIGURED_APP',
  });
};

export const clearErrorMessage = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_ERROR_MESSAGE',
  });
};

export const startFetchCase = () => (dispatch) => {
  dispatch({
    type: 'FETCHING_APPLICATION',
  });
};

const checkDocumentStatus = (documents, categories) => (dispatch) => {
  const minaUcs = documents.filter((doc) => doc.type === 'MIN_UC');
  const idProofs = documents.filter((doc) => doc.type === 'ID_PROOF');
  const incomeBases = documents.filter((doc) => doc.type === 'INCOME_BASE');
  const rentalBases = documents.filter((doc) => doc.type === 'RENTAL_BASE');
  const rentalAgreements = documents.filter(
    (doc) => doc.type === 'RENTAL_AGREEMENT'
  );

  const minUcCategoryStatus = get(categories, 'minUc.approvalStatus.type');
  const idProofCategoryStatus = get(categories, 'idProof.approvalStatus.type');
  const incomeBaseCategoryStatus = get(
    categories,
    'incomeBase.approvalStatus.type'
  );
  const rentalBaseCategoryStatus = get(
    categories,
    'rentalBase.approvalStatus.type'
  );
  const rentalAgreementCategoryStatus = get(
    categories,
    'rentalAgreement.approvalStatus.type'
  );

  dispatch({
    type: 'RECEIVE_DOCUMENT_CATEGORY_COMMENTS',
    comments: {
      minUcComment: {
        comment: get(categories, 'minUc.comment'),
        status: minUcCategoryStatus,
      },
      idProofComment: {
        comment: get(categories, 'idProof.comment'),
        status: idProofCategoryStatus,
      },
      rentalBaseComment: {
        comment: get(categories, 'rentalBase.comment'),
        status: rentalBaseCategoryStatus,
      },
      rentalAgreementComment: {
        comment: get(categories, 'rentalAgreement.comment'),
        status: rentalAgreementCategoryStatus,
      },
      incomeBaseComment: {
        comment: get(categories, 'incomeBase.comment'),
        status: incomeBaseCategoryStatus,
      },
    },
  });

  if (minaUcs.length === 0) {
    dispatch({ type: 'MIN_UC_STATUS', status: null });
  }
  if (idProofs.length === 0) {
    dispatch({ type: 'ID_PROOF_STATUS', status: null });
  }
  if (incomeBases.length === 0) {
    dispatch({ type: 'INCOME_BASE_STATUS', status: null });
  }
  if (rentalBases.length === 0) {
    dispatch({ type: 'RENTAL_BASE_STATUS', status: null });
  }
  if (rentalAgreements.length === 0) {
    dispatch({ type: 'RENTAL_AGREEMENT_STATUS', status: null });
  }

  if (
    minaUcs.filter((doc) => get(doc, 'approvalStatus.type') === 'UPDATED')
      .length > 0 ||
    minUcCategoryStatus === 'UPDATED'
  ) {
    dispatch({ type: 'MIN_UC_STATUS', status: 'UPDATED' });
  }
  if (
    idProofs.filter((doc) => get(doc, 'approvalStatus.type') === 'UPDATED')
      .length > 0 ||
    idProofCategoryStatus === 'UPDATED'
  ) {
    dispatch({ type: 'ID_PROOF_STATUS', status: 'UPDATED' });
  }
  if (
    incomeBases.filter((doc) => get(doc, 'approvalStatus.type') === 'UPDATED')
      .length > 0 ||
    incomeBaseCategoryStatus === 'UPDATED'
  ) {
    dispatch({ type: 'INCOME_BASE_STATUS', status: 'UPDATED' });
  }
  if (
    rentalBases.filter((doc) => get(doc, 'approvalStatus.type') === 'UPDATED')
      .length > 0 ||
    rentalBaseCategoryStatus === 'UPDATED'
  ) {
    dispatch({ type: 'RENTAL_BASE_STATUS', status: 'UPDATED' });
  }
  if (
    rentalAgreements.filter(
      (doc) => get(doc, 'approvalStatus.type') === 'UPDATED'
    ).length > 0 ||
    rentalAgreementCategoryStatus === 'UPDATED'
  ) {
    dispatch({ type: 'RENTAL_AGREEMENT_STATUS', status: 'UPDATED' });
  }

  if (
    minaUcs.filter((doc) => get(doc, 'approvalStatus.type') === 'REJECTED')
      .length !== 0 ||
    minUcCategoryStatus === 'REJECTED'
  ) {
    dispatch({ type: 'MIN_UC_STATUS', status: 'REJECTED' });
  }
  if (
    idProofs.filter((doc) => get(doc, 'approvalStatus.type') === 'REJECTED')
      .length !== 0 ||
    idProofCategoryStatus === 'REJECTED'
  ) {
    dispatch({ type: 'ID_PROOF_STATUS', status: 'REJECTED' });
  }
  if (
    incomeBases.filter((doc) => get(doc, 'approvalStatus.type') === 'REJECTED')
      .length !== 0 ||
    incomeBaseCategoryStatus === 'REJECTED'
  ) {
    dispatch({ type: 'INCOME_BASE_STATUS', status: 'REJECTED' });
  }
  if (
    rentalBases.filter((doc) => get(doc, 'approvalStatus.type') === 'REJECTED')
      .length !== 0 ||
    rentalBaseCategoryStatus === 'REJECTED'
  ) {
    dispatch({ type: 'RENTAL_BASE_STATUS', status: 'REJECTED' });
  }
  if (
    rentalAgreements.filter(
      (doc) => get(doc, 'approvalStatus.type') === 'REJECTED'
    ).length !== 0 ||
    rentalAgreementCategoryStatus === 'REJECTED'
  ) {
    dispatch({ type: 'RENTAL_AGREEMENT_STATUS', status: 'REJECTED' });
  }

  if (
    minaUcs.length > 0 &&
    minaUcs.filter((doc) => get(doc, 'approvalStatus.type') === 'APPROVED')
      .length === minaUcs.length &&
    minUcCategoryStatus === 'APPROVED'
  ) {
    dispatch({ type: 'MIN_UC_STATUS', status: 'APPROVED' });
  }
  if (
    idProofs.length > 0 &&
    idProofs.filter((doc) => get(doc, 'approvalStatus.type') === 'APPROVED')
      .length === idProofs.length &&
    idProofCategoryStatus === 'APPROVED'
  ) {
    dispatch({ type: 'ID_PROOF_STATUS', status: 'APPROVED' });
  }
  if (
    incomeBases.length > 0 &&
    incomeBases.filter((doc) => get(doc, 'approvalStatus.type') === 'APPROVED')
      .length === incomeBases.length &&
    incomeBaseCategoryStatus === 'APPROVED'
  ) {
    dispatch({ type: 'INCOME_BASE_STATUS', status: 'APPROVED' });
  }
  if (
    rentalBases.length > 0 &&
    rentalBases.filter((doc) => get(doc, 'approvalStatus.type') === 'APPROVED')
      .length === rentalBases.length &&
    rentalBaseCategoryStatus === 'APPROVED'
  ) {
    dispatch({ type: 'RENTAL_BASE_STATUS', status: 'APPROVED' });
  }
  if (
    rentalAgreements.length > 0 &&
    rentalAgreements.filter(
      (doc) => get(doc, 'approvalStatus.type') === 'APPROVED'
    ).length === rentalAgreements.length &&
    rentalAgreementCategoryStatus === 'APPROVED'
  ) {
    dispatch({ type: 'RENTAL_AGREEMENT_STATUS', status: 'APPROVED' });
  }
};

export const checkDocumentApproved = (documents, categories) => {
  const minaUcs = documents.filter((doc) => doc.type === 'MIN_UC');
  const idProofs = documents.filter((doc) => doc.type === 'ID_PROOF');
  const incomeBases = documents.filter((doc) => doc.type === 'INCOME_BASE');
  const rentalBases = documents.filter((doc) => doc.type === 'RENTAL_BASE');
  const rentalAgreements = documents.filter(
    (doc) => doc.type === 'RENTAL_AGREEMENT'
  );

  const minUcCategoryStatus = get(categories, 'minUc.approvalStatus.type');
  const idProofCategoryStatus = get(categories, 'idProof.approvalStatus.type');
  const incomeBaseCategoryStatus = get(
    categories,
    'incomeBase.approvalStatus.type'
  );
  const rentalBaseCategoryStatus = get(
    categories,
    'rentalBase.approvalStatus.type'
  );
  const rentalAgreementCategoryStatus = get(
    categories,
    'rentalAgreement.approvalStatus.type'
  );

  if (minaUcs.length === 0) return false;
  if (idProofs.length === 0) return false;
  if (incomeBases.length === 0) return false;
  if (rentalBases.length === 0) return false;
  if (rentalAgreements.length === 0) return false;

  if (
    minaUcs.filter(
      (doc) => doc.approvalStatus && doc.approvalStatus.type !== 'APPROVED'
    ).length !== 0 ||
    minUcCategoryStatus !== 'APPROVED'
  ) {
    return false;
  }
  if (
    idProofs.filter(
      (doc) => doc.approvalStatus && doc.approvalStatus.type !== 'APPROVED'
    ).length !== 0 ||
    idProofCategoryStatus !== 'APPROVED'
  ) {
    return false;
  }
  if (
    incomeBases.filter(
      (doc) => doc.approvalStatus && doc.approvalStatus.type !== 'APPROVED'
    ).length !== 0 ||
    incomeBaseCategoryStatus !== 'APPROVED'
  ) {
    return false;
  }
  if (
    rentalBases.filter(
      (doc) => doc.approvalStatus && doc.approvalStatus.type !== 'APPROVED'
    ).length !== 0 ||
    rentalBaseCategoryStatus !== 'APPROVED'
  ) {
    return false;
  }
  if (
    rentalAgreements.filter(
      (doc) => doc.approvalStatus && doc.approvalStatus.type !== 'APPROVED'
    ).length !== 0 ||
    rentalAgreementCategoryStatus !== 'APPROVED'
  ) {
    return false;
  }

  return true;
};

export const checkDocumentUploaded = (documents) => {
  const minaUcs = documents.filter((doc) => doc.type === 'MIN_UC');
  const idProofs = documents.filter((doc) => doc.type === 'ID_PROOF');
  const incomeBases = documents.filter((doc) => doc.type === 'INCOME_BASE');
  const rentalBases = documents.filter((doc) => doc.type === 'RENTAL_BASE');
  const rentalAgreements = documents.filter(
    (doc) => doc.type === 'RENTAL_AGREEMENT'
  );

  if (minaUcs.length === 0) return false;
  if (idProofs.length === 0) return false;
  if (incomeBases.length === 0) return false;
  if (rentalBases.length === 0) return false;
  if (rentalAgreements.length === 0) return false;

  return true;
};

export const checkStatus = (applicant) => (dispatch) => {
  const formChecks = [
    {
      type: 'members',
      id: 'member1',
    },
    {
      type: 'members',
      id: 'member2',
    },
    {
      type: 'apartments',
      id: 'apartment1',
    },
    {
      type: 'apartments',
      id: 'apartment2',
    },
    {
      type: 'details',
      id: 'details1',
    },
    {
      type: 'details',
      id: 'details2',
    },
  ];

  formChecks.forEach((check) => {
    if (!applicant[check.type][check.id]) return;

    if (
      check.type === 'details' &&
      applicant[check.type][check.id].approvalStatus !== null
    ) {
      dispatch({
        type: check.id,
        status: getApprovalstatus(applicant[check.type][check.id]),
      });
      return;
    }

    if (hasNull(applicant[check.type][check.id])) {
      dispatch({ type: check.id, status: null });
    } else {
      dispatch({
        type: check.id,
        status: getApprovalstatus(applicant[check.type][check.id]),
      });
    }
  });

  if (applicant.swapReason.approvalStatus) {
    dispatch({
      type: 'swapReason',
      status: getApprovalstatus(applicant.swapReason),
    });
  }

  if (applicant.documents.length !== 0) {
    dispatch(
      checkDocumentStatus(applicant.documents, applicant.documentCategories)
    );
  }

  if (applicant.members.member1.signLink) {
    dispatch({ type: 'LB_CONTROL_STATUS', status: 'APPROVED' });
    dispatch({ type: 'SIGN_STATUS', status: 'UPDATED' });
  }
  if (applicant.signed) dispatch({ type: 'SIGN_STATUS', status: 'APPROVED' });
};

const otherStatus = (applicant) => {
  const formChecks = [
    {
      type: 'members',
      id: 'member1',
    },
    {
      type: 'members',
      id: 'member2',
    },
    {
      type: 'apartments',
      id: 'apartment1',
    },
    {
      type: 'apartments',
      id: 'apartment2',
    },
    {
      type: 'details',
      id: 'details1',
    },
    {
      type: 'details',
      id: 'details2',
    },
  ];
  let formsApproved = true;
  let formsUpdated = true;
  formChecks.forEach((check) => {
    const form = applicant[check.type][check.id];
    if (form) {
      const apStatus = getApprovalstatus(form);
      if (apStatus !== 'APPROVED') formsApproved = false;
      if (apStatus !== 'APPROVED' && apStatus !== 'UPDATED') {
        formsUpdated = false;
      }
    }
  });
  let swapReasonApproved = true;
  let swapReasonUpdated = true;
  if (applicant.swapReason.approvalStatus) {
    const apStatus = getApprovalstatus(applicant.swapReason);
    if (apStatus !== 'APPROVED') swapReasonApproved = false;
    if (apStatus !== 'APPROVED' && apStatus !== 'UPDATED') {
      swapReasonUpdated = false;
    }
  }
  let documentsApproved = false;
  let documentsUpdated = false;
  if (applicant.documents.length !== 0 && applicant.documents) {
    documentsApproved = checkDocumentApproved(
      applicant.documents,
      applicant.documentCategories
    );
    documentsUpdated = checkDocumentUploaded(applicant.documents);
  }
  const gotSignLink = !!applicant.members.member1
    .signLink; /* eslint-disable-line no-unneeded-ternary */

  if (applicant.signed) return 'LANDLORD';
  if (formsApproved && documentsApproved && swapReasonApproved && gotSignLink) {
    return 'SIGNING';
  }
  if (formsUpdated && swapReasonUpdated && documentsUpdated) return 'VETTING';
  return 'GATHER_INFO';
};

export const checkOthersStatus = (applicants) => (dispatch) => {
  applicants.forEach((applicant) => {
    const stepperStatus = {
      applicantId: applicant.id,
      status: otherStatus(applicant),
    };
    dispatch({
      type: 'OTHER_STATUS',
      data: stepperStatus,
    });
  });
};

export const checkMember2 = (applicant) => (dispatch) => {
  if (applicant.members.member2) {
    dispatch({ type: 'SHOW_MEMBER2' });
  }
};

export const checkApartment2 = (applicant) => (dispatch) => {
  if (applicant.apartments.apartment2) {
    dispatch({ type: 'SHOW_APARTMENT2' });
  }
};

export const checkDetails2 = (application, currentApplicant) => (dispatch) => {
  let swapWithIndex = currentApplicant.index + 1;

  if (swapWithIndex >= application.applicants.length) swapWithIndex = 0;

  const swapWithApplicant = application.applicants.filter(
    (applicant) => applicant.index === swapWithIndex
  );

  if (swapWithApplicant[0].apartments.apartment2 !== null) {
    dispatch({ type: 'SHOW_DETAILS2' });
  }
};

export const checkIfAllStarted = (application) => (dispatch) => {
  let allStarted = true;
  const notStarted = [];

  application.applicants.forEach((applicant) => {
    if (!applicant.started) {
      allStarted = false;
      notStarted.push(applicant.members.member1.name);
    }
  });

  if (allStarted) {
    dispatch({
      type: 'HIDE_NOTIFICATION_BAR',
    });
  } else {
    dispatch({
      type: 'SHOW_NOTIFICATION_BAR',
      notStarted,
    });
  }
};

export const getIdentityId = (idToken, callback) => {
  const params = {
    IdentityPoolId: apiConfig.amplifyConfig.Auth.identityPoolId,
    Logins: {
      [apiConfig.amplifyConfig.loginString]: idToken,
    },
  };
  const cid = new CognitoIdentity({ apiVersion: '2014-06-30' });
  cid.config = {
    apiVersion: '2016-04-19',
    IdentityPoolId: apiConfig.amplifyConfig.Auth.identityPoolId,
    region: 'eu-west-1',
    globalEndpoint: 'https://cognito-identity.eu-west-1.amazonaws.com',
  };
  cid.endpoint = {
    hostname: 'cognito-identity.eu-west-1.amazonaws.com',
    host: 'cognito-identity.eu-west-1.amazonaws.com',
    href: 'https://cognito-identity.eu-west-1.amazonaws.com',
    protocol: 'https:',
    port: '443',
  };
  return cid.getId(params, callback);
};

export const getCase = () => {};

const renderApplicationPicker = (swaps) => (dispatch) => {
  dispatch({
    type: 'SET_PICKABLE_APPLICATIONS',
    swaps,
  });
};

export const success = () => (dispatch) => {
  apiCall(graphqlOperation(getAllApplications()))
    .then((res) => {
      if (
        !res.data ||
        (res.data && !res.data.applications) ||
        (res.data && res.data.applications.length < 1)
      ) {
        redirectToLoginPage();
      }

      const activeApplications = res.data.applications.filter(
        (application) => application.status !== 'REMOVED'
      );
      if (activeApplications.length === 0) {
        redirectToLoginPage();
      }

      const swaps = [];
      activeApplications.forEach((application) => {
        const userApplicant = application.applicants.filter(
          (applicant) => applicant.email !== null
        );
        const applicationAddresses = application.applicants.map(
          (applicant) => applicant.apartments.apartment1.address
        );

        const swap = {
          id: userApplicant[0].id,
          addresses: applicationAddresses,
          status: application.status,
          image: userApplicant[0].image,
        };
        swaps.push(swap);
      });

      const applicantIds = activeApplications.map((application) =>
        application.applicants.filter((applicant) => applicant.email !== null)
      );

      if (applicantIds.length > 1) {
        dispatch(renderApplicationPicker(swaps));
      } else {
        dispatch(applicationActions.fetchCase(applicantIds[0][0].id));
      }
    })
    .catch((error) => {
      window.debug.log(error);
      redirectToLoginPage();
    });
};

export const pickApplication = (id) => (dispatch) => {
  dispatch({
    type: 'CLOSE_APPLICATION_PICKER',
  });

  dispatch(applicationActions.fetchCase(id));
};

function getCognitoUser() {
  const poolData = {
    UserPoolId: apiConfig.amplifyConfig.Auth.userPoolId,
    ClientId: apiConfig.amplifyConfig.Auth.userPoolWebClientId,
  };
  const userPool = new CognitoUserPool(poolData);

  return new CognitoUser({
    Username: 'anon@domain.com',
    Pool: userPool,
  });
}

export const cognitoLoginRefreshToken = (credentials) => async (dispatch) => {
  const { refreshToken } = credentials;

  const RefreshToken = new CognitoRefreshToken({
    RefreshToken: refreshToken,
  });

  const user = getCognitoUser();

  return new Promise((resolve) => {
    user.refreshSession(RefreshToken, async (err, data) => {
      if (err) {
        dispatch({
          type: 'AUTHENTICATE_FAILED',
          err,
        });

        localStorage.clear();
        redirectToLoginPage(window.propositionID);
        return;
      }

      const { idToken } = data;
      const { IdentityId } = await getIdentityId(idToken.jwtToken).promise();
      dispatch({
        type: 'AUTHENTICATE_SUCCESS',
        identityId: IdentityId,
      });

      dispatch(success());
      resolve();
    });
  });
};

export const setLBControlStatusUpdated = () => (dispatch) =>
  dispatch({ type: 'LB_CONTROL_STATUS', status: 'UPDATED' });



// WEBPACK FOOTER //
// ./src/features/App/actions.js